<article class="project-details-origin-version">
    <header>
        <h3>ORIGINAL ARTWORK</h3>
    </header>
    <core-versions-summary-box
        [version]="version"
        [menu]="menu"
        [feedbacks]="getFeedbacks(version)"
        (menuClick)="onMenuClick($event)"
        (actionFileClick)="onFileClick($event)"
    ></core-versions-summary-box>

</article>
